import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Spinner from '../../components/UI/Spinner/Spinner';
import CreateGroup from '../../containers/CreateGroup/CreateGroup';
import DNSServer from '../../containers/DNSServer/DNSServer';
import GroupDetailPage from '../../containers/GroupDeviceDetails/GroupDeviceDetails';
import GroupsList from '../../containers/GroupsList/GroupsList';
import IpReservations from '../../containers/IpReservations/IpReservations';
import JsonData from '../../containers/JsonData/JsonData';
import MultipleAdvancedInHomeWifi from '../../containers/MultipleAdvancedInHomeWifi/MultipleAdvancedInHomeWifi';
import Upnp from '../../containers/Upnp/Upnp';
import Box from '../../hoc/Box/Box';
import * as actions from '../../store/actions/index';
import Error from '../UI/Error/Error';
import Modal from '../UI/Modal/Modal';
import Success from '../UI/Success/Success';
import classes from './AdvancedConfigurationsPage.css';
import StaticIP from '../../containers/StaticIP/StaticIP'


const AdvancedConfigurationsPage = (props) => {

  const { location, deviceGroups, realUpnp, realDns, realDhcp, upnpLoading, upnpLoaded,
  dhcpLoaded, dhcpLoading, devicesLoaded, devicesLoading, realDevices,
  dnsLoaded, dnsLoading, groupLoaded, groupLoading, pauseDeviceGroupSuccess,
  devicesByEquipment, groupError, groupSuccess, resetDeviceGroupSuccessError, resetDhcpErrorSuccess} = props;

  const [myRef, setMyRef] = useState(null);
  const [upnpReset, setUpnpReset] = useState(false);
  const [isGroupDetailsOpen, setIsGroupDetailsOpen] = useState(false);
  const [currentGroupDetails, setCurrentGroupDetails] = useState({});
  const [showMoveDevice, setShowMoveDevice] = useState('edit');
  const [selectedDeviceMac, setSelectedDeviceMac] = useState(undefined);
  const [ipReservationsError, setIpReservationsError] = useState(props.IpReservationsError);
  const [ipReservationsSuccess, setIpReservationsSuccess] = useState(props.IpReservationsSuccess);

  useEffect(() => {
    setIpReservationsError(props.IpReservationsError);
    setIpReservationsSuccess(props.IpReservationsSucces);
  }, [props.IpReservationsError, props.IpReservationsSuccess])

  useEffect(() => {
    if(myRef){
      executeScroll()
    }

    if ( location?.query?.groupName ) {
      renderDeviceGroup();
    }
  },[myRef, location])

  useEffect(() => {
    if(myRef){
      executeScroll()
    }
  })

  const renderDeviceGroup = () => {
    let group = deviceGroups.filter(
      (g) => g.nickname === location.query.groupName
    );
    if (group.length > 1) {
      group.forEach((g) => {
        if (g.devices.length > 1) {
          g.devices.forEach((element) => {
            if (element.mac === location.query.deviceMac) {
              group[0] = g;
            }
          });
        }
      });
    }
    setCurrentGroupDetails(group[0]);
    setIsGroupDetailsOpen(true);

    if (
      location?.query?.showMoveDeviceModal
    ) {
      setShowMoveDevice('move');
    }
    if (
      location?.query?.deviceMac
    ) {
      setSelectedDeviceMac(location.query.deviceMac);
    }
  }

  const resetUpnpHandler = () => {
    setUpnpReset(true);
    setTimeout(() => {
      setUpnpReset(true);
    }, 1);
  };

  const executeScroll = () => myRef.scrollIntoView();

  const TDCSisGroupPauseEnabled = sessionStorage.getItem('TDCSisGroupPauseEnabled');

  const upnp = useMemo(() => {

    if (
      upnpLoading ||
      !upnpLoaded ||
      upnpReset
    ) {
      return <Spinner />;
    } else {
      return (
        <Upnp
          originalUpnp={realUpnp}
          resetUpnp={resetUpnpHandler}
        />
      );
    }

  }, [upnpLoading, upnpLoaded, upnpReset])

  const dhcp = useMemo(() => {
    if (
      dhcpLoading ||
      !dhcpLoaded ||
      devicesLoading ||
     !devicesLoaded
    ) {
      return <Spinner />;
    } else {
      return (
        <IpReservations
          realDevices={realDevices}
          realDhcp={realDhcp}
        />
      );
    }
  }, [dhcpLoading, dhcpLoaded, devicesLoading, devicesLoaded])

  const dns = useMemo(() => {
    if (dnsLoading || !dnsLoaded) {
      return <Spinner />;
    } else {
      return (
        <DNSServer
          originalPrimaryDns={
            realDns?.enabled ? realDns?.primaryDns : ''
          }
          originalSecondaryDns={
            realDns?.enabled
              ? realDns?.secondaryDns === undefined
                ? ''
                : realDns.secondaryDns
              : ''
          }
        />
      );
    }
  }, [dnsLoading, dnsLoaded, realDns])

  const groupDevicesSection = () => {
    if (
    groupLoading ||
      !groupLoaded
    ) {
      return <Spinner />;
    } else if(!pauseDeviceGroupSuccess){

      let groupDeviceDetails = deviceGroups.filter(
        (g) =>
          currentGroupDetails &&
          currentGroupDetails &&
          currentGroupDetails.id &&
          g.id === currentGroupDetails.id
      );
      groupDeviceDetails = groupDeviceDetails[0];

     return (
        <GroupDetailPage
          groupLoaded={groupLoaded}
          groupLoading={groupLoading}
          pauseDeviceGroupSuccess={pauseDeviceGroupSuccess}
          groupDetails={groupDeviceDetails}
          enableGroupPause={TDCSisGroupPauseEnabled}
          closeGroupDetailsPage={() => {
            setIsGroupDetailsOpen(false);
            setCurrentGroupDetails({});
            setShowMoveDevice('edit');
            setSelectedDeviceMac(undefined);
          }}
          devicesByEquipment={devicesByEquipment}
          groups={deviceGroups}
          showMoveDevice={showMoveDevice}
          selectedDeviceMac={selectedDeviceMac}
        />
      );
    }else{
     return <div />;
    }
  }


    if (!realUpnp || !realDns) {
      return <Spinner />;
    } else {

    const staticIP = sessionStorage.getItem("featureFlags")?.includes('staticIP')
          ? (<><StaticIP /><div className={classes.Spacer} /></>)
          :<div/>;

      return (
        <Box ref={setMyRef}>
          <div className={classes.MainContent}>
            <div className={classes.MainContentContainer}>
              {staticIP}
              <div className={[classes.Spacer].join(' ')} />
              {isGroupDetailsOpen ? (
                <Box>
                  { groupDevicesSection() }
                </Box>
              ) : (
                <React.Fragment>
                  {dhcp}
                  <div className={[classes.Spacer].join(' ')} />

                  {dns}
                  <div className={classes.Spacer} />

                  {upnp}
                  <div className={classes.Spacer} />

                  <MultipleAdvancedInHomeWifi />

      {!sessionStorage.getItem('type')?.includes('Business') && !sessionStorage.getItem('type')?.includes('unknown') && !sessionStorage.getItem('type')?.includes('undefined') && !sessionStorage.getItem('featureFlags')?.includes('isVar') &&
                <React.Fragment>
                  <GroupsList
                    groups={deviceGroups}
                    loading={groupLoading}
                    loaded={groupLoaded}
                    enableGroupPause={TDCSisGroupPauseEnabled}
                    showGroupDetails={(group) => {

                      setCurrentGroupDetails(group);
                      setIsGroupDetailsOpen(true);
                      setShowMoveDevice('edit');
                      setSelectedDeviceMac(undefined);

                    }}
                  />
                  <div className={classes.Spacer} />

                  <CreateGroup

                    groups={deviceGroups}
                    devicesByEquipment={devicesByEquipment}
                    loading={groupLoading}
                    loaded={groupLoaded}
                  />

                  <div className={classes.Spacer} />
                  </React.Fragment>}
                  <JsonData />
                </React.Fragment>
              )}
            </div>
          </div>

          {groupError && (
            <Modal
              show={groupError}
              modalClosed={() => {
                resetDeviceGroupSuccessError();
              }}
            >
              <Error id={'AdvancedConfigurationsPageError'} />
            </Modal>
          )}
          {groupSuccess && (
            <Modal
              show={groupSuccess}
              modalClosed={() => {
                resetDeviceGroupSuccessError();
              }}
            >
              <Success id={'AdvancedConfigurationsPageSuccess'} />
            </Modal>
          )}

          {ipReservationsError && (
            <Modal show={ipReservationsError} modalClosed={() => { resetDhcpErrorSuccess(); }}>
            <Error id={'IPReservationsError'} />
          </Modal>
          )}
          {ipReservationsSuccess && (
          <Modal show={ipReservationsSuccess} modalClosed={() => { resetDhcpErrorSuccess(); }}>
            <Success id={'IPReservationsSuccess'} />
          </Modal>
          )


          }
        </Box>
      );
    }

}

const mapStateToProps = (state) => {
  return {
    realUpnp: state.upnp.realUpnp,
    realDns: state.dns.realDns,
    realDevices: state.devices.realDevices,
    devicesByEquipment: state.devices.devicesByEquipment,
    realDhcp: state.dhcp.realDhcp,
    devicesLoading: state.devices.loading,
    devicesLoaded: state.devices.loaded,
    upnpLoading: state.upnp.loading,
    upnpLoaded: state.upnp.loaded,
    dnsLoading: state.dns.loading,
    dnsLoaded: state.dns.loaded,
    dhcpLoading: state.dhcp.loading,
    dhcpLoaded: state.dhcp.loaded,
    deviceGroups: state.deviceGroups.deviceGroups,
    groupLoading: state.deviceGroups.loading,
    groupLoaded: state.deviceGroups.loaded,
    groupSuccess: state.deviceGroups.success,
    groupError: state.deviceGroups.error,
    pauseDeviceGroupSuccess: state.deviceGroups.pauseDeviceGroupSuccess,
    IpReservationsSuccess: state.dhcp.success,
    IpReservationsError: state.dhcp.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetDeviceGroupSuccessError: () =>
      dispatch(actions.resetDeviceGroupSuccessError()),
    resetDhcpErrorSuccess: () => dispatch(actions.resetDhcpErrorSuccess()),
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdvancedConfigurationsPage));

